<template>
  <section>
    <div class="list">
      <div class="tr tr_title">
        <span>Name (English)</span>
        <span>Name (Chinese)</span>
        <span>Actions</span>
      </div>
      <section ref="sortable">
        <div
          v-for="(val,i) in categoriesData"
          :key="i + val.name"
          class="tr">
          <span>{{val.languages['en-US']}}</span>
          <span>{{val.languages['zh-HK']}}</span>
          <span class="actions">
            <span
              @click="handlerEdit(val)" >
              <font-awesome-icon
                icon="pen"
                class="icon_pen"/>
            </span>
            <span
              @click="handlerDel(val)" >
              <font-awesome-icon
                icon="trash-alt"
                class="icon_del"/>
            </span>
            <span
              @mousedown="handleClick(val)"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
            >
              <font-awesome-icon
                icon="grip-lines"
                class="icon_lines"/>
            </span>
          </span>
        </div>
      </section>

      <category-popup
        :id="editCategoryId"
        ref="category-popup"
        v-model="categoryDialog"
        :form="editCategoryData"
        :isEdit="isEdit"
        @update="handlerCategoryUpdate" />
      
    </div>
  </section>
</template>

<script>
import {
  getNewsCategoriesList,
  patchNewsCategory,
  getNewsCategoryDetail
} from '@/api/news'

import Sortable from 'sortablejs'

import CategoryPopup from './popup/category-popup'

export default {
  name: 'BlogCategoryList',
  components: {
    CategoryPopup
  },
  data () {
    return {
      categoriesData: [],
      sortable: {},
      category_id: -1,
      editCategoryId: -1,
      editCategoryData: null,
      categoryDialog: false,
    }
  },
  computed: {
    isEdit() {
      return this.editCategoryId != -1
    },
  },
  mounted(){
    this.network().getNewsCategoriesList()
    let el = this.$refs['sortable']
    this.createSort(el)
  },
  methods: {
    changeDialog(){
      this.categoryDialog = true
      this.resetForm()
    },

    resetForm(){
      this.editCategoryId = -1
      this.category_id = -1
      this.editCategoryData = null
      this.$refs['category-popup'].resetForm()
    },

    handlerCancel() {
      this.categoryDialog = false
    },

    handlerEdit(row) {
      const { category_id } = row
      this.editCategoryId = category_id
      this.network().getNewsCategoryDetail()
    },

    handlerDel(row) {
      this.$ConfirmBox({
        message: `Are you sure to delete this category（ ${row.languages['en-US']} | ${row.languages['zh-HK']} ）?`
      }).then(() => {
        const { category_id } = row
        let params = {
          category_id,
          action_name: 'delete'
        }
        this.network().patchNewsCategory(params)
      })
    },
    handleMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.sortable.option('disabled', true)
    },
    handleMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.sortable.option('disabled', false)
    },

    handleClick(val) {
      this.category_id = val.category_id
    },

    sortEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          category_id: this.category_id,
          old_index: e.oldIndex,
          new_index: e.newIndex,
          action_name: 'order'
        }
        this.network().patchNewsCategory(params)
      }
    },

    createSort(el){
      this.sortable = new Sortable(el,{
        ghostClass: 'blue',
        disabled: true,
        onEnd: this.sortEnd
      })
    },
    handlerCategoryUpdate() {
      this.network().getNewsCategoriesList({
        hideLoading: true
      })
    },
    network(){
      return {
        getNewsCategoriesList: async () => {
          const { data } = await getNewsCategoriesList()
          data.map((item, index) => {
            let { languages = [] } = item
            if(languages instanceof Array) {
              item.languages = {
                'zh-HK': '',
                'en-US': ''
              }
            }
            return item
          })
          this.categoriesData = data
          this.$emit('get-list', this.categoriesData)
        },
        patchNewsCategory: async params => {
          const { data } = await patchNewsCategory(params)
          this.$message({
            type: 'success',
            message: data.message_language
          })
          this.network().getNewsCategoriesList({
            hideLoading: true
          })
        },
        getNewsCategoryDetail: async () => {
          const { data } = await getNewsCategoryDetail({
            category_id: this.editCategoryId
          })
          this.editCategoryData = data
          this.categoryDialog = true
        },
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.blue{
  background: #ecf5ff;
}
.form-item{
  padding-bottom: 16px !important;
  span{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292e;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.list{
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: white;
    .tr_title{
      font-weight: bold;
      color: #909399;
      background: #f6f8fa;
    }
    .tr{
      padding: 10px;
      height: 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 14px;
      &>span{
        flex: 1;
        text-align: center;
      }
      .actions{
        span{
          margin-right: 20px;
          padding: 5px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          .icon_pen{
            color: rgba(3, 102, 214, 1);
          }
          .icon_del{
            color: rgba(203, 36, 49, 1);
          }
          .icon_lines{
            color: rgba(209, 213, 218, 1);
          }
        }
      }
    }
    .tr+.tr{
      border-top: 1px solid #EAECEF;
    }
  }
.dialog-container {
  padding: 15px;
}
</style>
